// extracted by mini-css-extract-plugin
export default {"itemview":"bd0eed202f493fcd6ecf","name":"d636493bed6aa6ddf7eb"};